import { render, staticRenderFns } from "./addEdit.vue?vue&type=template&id=1d492ce0"
import script from "./addEdit.vue?vue&type=script&lang=js"
export * from "./addEdit.vue?vue&type=script&lang=js"
import style0 from "./addEdit.vue?vue&type=style&index=0&id=1d492ce0&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d492ce0')) {
      api.createRecord('1d492ce0', component.options)
    } else {
      api.reload('1d492ce0', component.options)
    }
    module.hot.accept("./addEdit.vue?vue&type=template&id=1d492ce0", function () {
      api.rerender('1d492ce0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/invoiceCenter/insuranceServiceConfiguration/addEdit.vue"
export default component.exports